import { Divider, Grid, Typography } from "@material-ui/core";
import { Delete } from "@material-ui/icons";
import ConfirmationButton from "components/ConfirmationButton";
import { RootState } from "config/store";
import { useSnackbar } from "notistack";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { DailyReport } from "shared/network/daily-report.api";
import {
  RelDailyReportCashFlow,
  deleteRelDailyReportCashFlow,
} from "shared/network/rel-daily-report-cash-flow.api";

type Props = {
  index: number;
  dailyReport?: DailyReport | null;
  relDailyReportCashFlow: RelDailyReportCashFlow;
  refetch: () => void;
  isClosed: boolean;
};

const DailyReportCreateCashFlowRow = ({
  index,
  dailyReport,
  relDailyReportCashFlow,
  refetch,
  isClosed,
}: Props) => {
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const tenant = useSelector((state: RootState) => state?.authentication?.selectedRelTenant);

  async function onDelete(id: number) {
    try {
      if (dailyReport?.id) {
        await deleteRelDailyReportCashFlow(id, tenant?.id);
        refetch();
      }
      enqueueSnackbar(t("dailyReport.deleteSuccess"), {
        variant: "success",
      });
    } catch {
      enqueueSnackbar(t("dailyReport.deleteError"), {
        variant: "error",
      });
    }
  }

  return (
    <Grid container spacing={1} alignItems="center">
      <Grid item xs={6}>
        <Typography>{relDailyReportCashFlow?.user?.name}</Typography>
      </Grid>
      <Grid item xs={4}>
        <Typography>
          {relDailyReportCashFlow?.cashAmount} {dailyReport?.project?.currency?.postfix}
        </Typography>
      </Grid>
      <Grid item xs={2} container justifyContent="flex-end">
        {!isClosed && (
          <ConfirmationButton
            variant="text"
            size="small"
            color="primary"
            buttonType="ICON"
            title={t("dailyReport.removeCashFlowTitle")}
            body={t("dailyReport.removeCashFlowBody")}
            onSubmit={() => onDelete(relDailyReportCashFlow?.id)}
          >
            <Delete />
          </ConfirmationButton>
        )}
      </Grid>
      <Grid item xs={12}>
        <Divider style={{ marginBottom: 4 }} />
      </Grid>
    </Grid>
  );
};

export default DailyReportCreateCashFlowRow;
